var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card bg-purple" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _vm._v("Αναζήτηση Πανεπιστημίων\r\n    "),
        _c(
          "el-button",
          {
            staticStyle: { float: "right", padding: "3px 0" },
            attrs: { type: "text" },
            on: { click: _vm.toggleUniSearch }
          },
          [_vm._v("\r\n      Κλείσιμο\r\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text item" },
      [
        _c(
          "el-form",
          { attrs: { "label-width": "110px" } },
          [
            _c(
              "el-form-item",
              { attrs: { label: "Χώρα" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "countries",
                    attrs: {
                      "value-key": "id",
                      placeholder: "Χώρα",
                      filterable: "filterable",
                      clearable: "clearable"
                    },
                    on: { change: _vm.selectedCountryUpdated },
                    model: {
                      value: _vm.selCountry,
                      callback: function($$v) {
                        _vm.selCountry = $$v
                      },
                      expression: "selCountry"
                    }
                  },
                  _vm._l(_vm.countries, function(country) {
                    return _c("el-option", {
                      key: country.id,
                      attrs: { label: country.name, value: country }
                    })
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.showCountryDetails
              ? _c(
                  "el-card",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: this.gettingCountryDetails,
                        expression: "this.gettingCountryDetails"
                      }
                    ],
                    staticClass: "box-card bg-purple-light",
                    attrs: { hit: "", shadow: "" }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { "label-width": "110px" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: this.selCountryDetails != "",
                                        expression:
                                          "this.selCountryDetails!= ''"
                                      }
                                    ],
                                    attrs: { label: "Ονομα", size: "small" }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(this.selCountryDetails.name) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: this.selCountryDetails != "",
                                        expression:
                                          "this.selCountryDetails!= ''"
                                      }
                                    ],
                                    attrs: {
                                      label: "Προηγ. όνομα",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(this.selCountryDetails.ex_name) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: this.selCountryDetails != "",
                                        expression:
                                          "this.selCountryDetails!= ''"
                                      }
                                    ],
                                    attrs: {
                                      label: "Συντομογραφία",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selCountryDetails.short_name
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Πανεπιστήμια" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "big",
                    attrs: {
                      "value-key": "id",
                      placeholder: "Πανεπιστήμιο",
                      filterable: "filterable",
                      clearable: "clearable",
                      disabled: _vm.disabledUni
                    },
                    on: { change: _vm.selectedUniversityUpdated },
                    model: {
                      value: _vm.selUniversity,
                      callback: function($$v) {
                        _vm.selUniversity = $$v
                      },
                      expression: "selUniversity"
                    }
                  },
                  _vm._l(_vm.selCountryUniversities, function(university) {
                    return _c("el-option", {
                      key: university.id,
                      attrs: { label: university.name, value: university }
                    })
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.showUniDetails
              ? _c(
                  "el-card",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: this.gettingUniversityDetails,
                        expression: "this.gettingUniversityDetails"
                      }
                    ],
                    staticClass: "box-card bg-purple-light",
                    attrs: { hit: "", shadow: "" }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { "label-width": "110px" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Όνομα", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selUniversityDetails.name) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Πρ. όνομα", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selUniversityDetails.ex_name) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Παν/μιο", size: "small" }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selUniversityDetails
                                              .university_type_status,
                                            "university_type_status"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Ενεργό", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selUniversityDetails.active,
                                            "active"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Τύπος", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(this.selUniversityDetails.type) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αναγνώριση",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selUniversityDetails
                                              .accredited,
                                            "accredited"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Συνεδρίας",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.meeting
                                            .meeting_no
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Πράξης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.epitropi_id
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Διεύθυνση", size: "small" }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.address
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Πόλη", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.city.name
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Πολιτεία", size: "small" }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.state.name
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Τηλέφωνο", size: "small" }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.phone
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Τηλέφωνο 2",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.other_phone
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Φαξ", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.fax_no
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "E-mail", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.email
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Μη παν/κο ίδρυμα",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails
                                            .non_universities_type_id
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Για Διαδίκτυο",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selUniversityDetails.h_internet
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Σχόλια", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selUniversityDetails.comments) +
                                "\r\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Κολλέγια" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "big",
                    attrs: {
                      "value-key": "id",
                      placeholder: "Κολλέγιο",
                      filterable: "filterable",
                      clearable: "clearable",
                      disabled: _vm.disabledCol
                    },
                    on: { change: _vm.selectedCollegeUpdated },
                    model: {
                      value: _vm.selCollege,
                      callback: function($$v) {
                        _vm.selCollege = $$v
                      },
                      expression: "selCollege"
                    }
                  },
                  _vm._l(_vm.selUniColleges, function(college) {
                    return _c("el-option", {
                      key: college.id,
                      attrs: { label: college.name, value: college }
                    })
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.showCollegeDetails
              ? _c(
                  "el-card",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: this.gettingCollegeDetails,
                        expression: "this.gettingCollegeDetails"
                      }
                    ],
                    staticClass: "box-card bg-purple-light",
                    attrs: { hit: "", shadow: "" }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { "label-width": "130px" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Όνομα", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selCollegeDetails.name) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αναγνώριση",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selCollegeDetails.accredited,
                                            "accredited"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Πράξης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selCollegeDetails.epitropi_id
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Συνεδρίασης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selCollegeDetails.meeting
                                            .meeting_no
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Ενεργό", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(
                                  _vm.translate(
                                    this.selCollegeDetails.active,
                                    "active"
                                  )
                                ) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Σχόλια", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selCollegeDetails.comments) +
                                "\r\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Σχολές" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "big",
                    attrs: {
                      "value-key": "id",
                      placeholder: "Σχολή",
                      filterable: "filterable",
                      clearable: "clearable",
                      disabled: _vm.disabledFac
                    },
                    on: { change: _vm.selectedFacultyUpdated },
                    model: {
                      value: _vm.selFaculty,
                      callback: function($$v) {
                        _vm.selFaculty = $$v
                      },
                      expression: "selFaculty"
                    }
                  },
                  _vm._l(_vm.selUniColFaculties, function(faculty) {
                    return _c("el-option", {
                      key: faculty.id,
                      attrs: { label: faculty.name, value: faculty }
                    })
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.showFacultyDetails
              ? _c(
                  "el-card",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: this.gettingFacultyDetails,
                        expression: "this.gettingFacultyDetails"
                      }
                    ],
                    staticClass: "box-card bg-purple-light",
                    attrs: { hit: "", shadow: "" }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { "label-width": "130px" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Όνομα Σχολής", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selFacultyDetails.name) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αναγνώριση",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selFacultyDetails.accredited,
                                            "accredited"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Πράξης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selFacultyDetails.epitropi_id
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Συνεδρίασης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selFacultyDetails.meeting
                                            .meeting_no
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Ενεργή", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(
                                  _vm.translate(
                                    this.selFacultyDetails.active,
                                    "active"
                                  )
                                ) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Σχόλια", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selFacultyDetails.comments) +
                                "\r\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Τμήματα" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "big",
                    attrs: {
                      "value-key": "id",
                      placeholder: "Τμήμα",
                      filterable: "filterable",
                      clearable: "clearable",
                      disabled: _vm.disabledDept
                    },
                    on: { change: _vm.selectedDepartmentUpdated },
                    model: {
                      value: _vm.selDepartment,
                      callback: function($$v) {
                        _vm.selDepartment = $$v
                      },
                      expression: "selDepartment"
                    }
                  },
                  _vm._l(_vm.selUniColFacDepartments, function(department) {
                    return _c("el-option", {
                      key: department.id,
                      attrs: { label: department.name, value: department }
                    })
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.showDepartmentDetails
              ? _c(
                  "el-card",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: this.gettingDepartmentDetails,
                        expression: "this.gettingDepartmentDetails"
                      }
                    ],
                    staticClass: "box-card bg-purple-light",
                    attrs: { hit: "", shadow: "" }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { "label-width": "130px" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Όνομα", size: "small" } },
                          [
                            _vm._v(
                              "\r\n            " +
                                _vm._s(this.selDepartmentDetails.name) +
                                "\r\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αναγνώριση",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selDepartmentDetails
                                              .accredited,
                                            "accredited"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Πρόγραμμα/Σχολή",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selDepartmentDetails.programme,
                                            "programme"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Ενεργό", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          _vm.translate(
                                            this.selDepartmentDetails.active,
                                            "active"
                                          )
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { type: "flex" } },
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Πράξης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selDepartmentDetails.epitropi_id
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Αρ. Συνεδρίασης",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selDepartmentDetails.meeting
                                            .meeting_no
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Σχόλια", size: "small" } },
                                  [
                                    _vm._v(
                                      "\r\n                " +
                                        _vm._s(
                                          this.selDepartmentDetails.comments
                                        ) +
                                        "\r\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6734c072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6734c072","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SearchUni.vue
// module id = null
// module chunks = 